import ProductFamilyList from "./ProductFamilyList";

export default ProductFamilyList;
